import { inject } from '@angular/core';
import { Params, Router } from '@angular/router';

export function injectClearQueryParams() {
  const router = inject(Router);

  const clearQueryParam = (param: Params) =>
    router.navigate([], {
      queryParams: param,
      queryParamsHandling: 'merge',
    });

  return clearQueryParam;
}
